import React from 'react'
import PropTypes from 'prop-types'
import Interweave from 'interweave'
import { convertMdToHtml } from '..'
import Section from '../../Section'

const AdherenceToBestPractices = ({ report: { reportContent } }) => (
  <Section title="Adherence to Best Practices">
    <Interweave
      content={convertMdToHtml.makeHtml(
        reportContent.breakdownAndAutomatedAnalysis.bestPracticesText,
      )}
    />
  </Section>
)

AdherenceToBestPractices.propTypes = {
  report: PropTypes.object,
}

export default AdherenceToBestPractices
